import React from "react";
import styled, { css } from "styled-components";
import { NavLink } from "Components/NavLink";
import { MenuMode, useMenuContext } from "Components/MenuProvider";
import { Body2 } from "melodies-source/Text";

interface Props {
  icon: React.ReactNode;
  label: string;
  caption?: string;
  to?: string;
  onClick?: () => void;
  exact?: boolean;
}

export type LinkItem = Props;

export const Link: React.FC<Props> = ({
  icon,
  label,
  caption,
  to,
  onClick,
  exact,
}) => {
  const { menuMode } = useMenuContext();
  const Component = to ? NavLink : StyledAnchor;
  const props = {
    ...(to && { to, exact }),
    ...(onClick && { onClick }),
    caption,
  };
  return (
    <Container menuMode={menuMode} hasCaption={!!caption}>
      <Component {...props} label={label}>
        {icon}
        {menuMode === "expanded" &&
          (caption ? (
            <Content>
              {label}
              <Body2>{caption}</Body2>
            </Content>
          ) : (
            label
          ))}
      </Component>
    </Container>
  );
};

interface ContainerProps {
  menuMode: MenuMode;
  hasCaption: boolean;
}

const Container = styled.div<ContainerProps>`
  svg {
    flex-shrink: 0;
    ${({ menuMode }) =>
      menuMode === "expanded" &&
      css`
        margin-right: 20px;
      `}

    ${({ hasCaption, menuMode }) =>
      hasCaption &&
      ((menuMode === "expanded" && "margin-top: -14px;") ||
        (menuMode === "collapsed" && "margin-top: 0px;"))}
  }
`;

const StyledAnchor = styled.a`
  cursor: pointer;
  display: flex;
  align-items: center;
  padding: 0 0 0 32px;
  color: inherit;
  font-weight: 500;
  line-height: 24px;
  height: 44px;
  font-family: Poppins;
  font-size: 16px;
  letter-spacing: 0;
  text-decoration: none;
  white-space: nowrap;
  &.active {
    color: #1b0076;
    background-color: #e8e5f1;
    border-radius: 0 24px 24px 0;
    font-weight: 600;

    ${({ theme }) =>
      theme.custom &&
      css`
        background-color: ${theme.custom.layout.sideBar.active.background};
        color: ${theme.custom.layout.sideBar.active.color};
      `};
  }
`;

const Content = styled.div`
  display: flex;
  flex-direction: column;
  ${Body2} {
    margin-top: -3px;
    color: #999999;
  }

  ${({ theme }) =>
    theme.custom &&
    css`
      ${Body2} {
        color: ${theme.custom.layout.sideBar.active.color};
      }
    `};
`;
